import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import LatestBook from "../components/LatestBook";
import About from "../components/About";
import Works from "../components/Works";
import Testimonials from "../components/Testimonials";
import Blog from "../components/Blog";
import Contact from "../components/Contact";
import BookClub from "../components/BookClub";

export default function App() {
  return (
    <>
      <Navigation />
      <Hero />
      <LatestBook />
      <BookClub />
      <About />
      <Works />
      <Testimonials />
      <Blog />
      <Contact />
    </>
  );
}